// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.schedule.scheduleitem.recurrence.RecurPatternDailyResponse */
/* istanbul ignore next */
@GandalfModel
export class RecurPatternDailyResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	dailyAmount!: number | null;

	@GandalfConstantDecorator(constants.DailyPatternType)
	@GandalfProperty({ designType: constants.DailyPatternType })
	dailyPatternType!: constants.DailyPatternType | null;

}
